var map = {
	"./bd-default.png": "8SCP",
	"./im-default.png": "80gS",
	"./sb-default.png": "DmO6",
	"./ss-default.png": "55jw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "M0Ai";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/sport ^\.\/.*\-default\.png$
// module id = M0Ai
// module chunks = 3